import StatusBadge from "components/Common/StatusBadge"
import { formatReadableDate } from "utils/formatDate"

const StockStatusCell = ({ stock }) => {
  return (
    <div className="text-wrap">
      {stock.location?.name ?? "-"}

      <div className="text-muted d-block mt-1">
        {stock.status ? <StatusBadge value={stock.status} /> : "-"}
      </div>
      {/* created_at: added in stocks */}
      <small className="text-muted d-block mt-1">
        {stock.created_at ? formatReadableDate(stock.created_at) : "-"}
      </small>
    </div>
  )
}

export default StockStatusCell
